import type { SupplierAccountOption } from '../../../../hooks/useFetchCreditorBalanceSummaryAccounts'

const getAccountAnalyticsLabel = (account: SupplierAccountOption): string =>
  [account.accountNumber, account.name].filter(Boolean).join(' - ')

// Unlike `formatAccountsPreview` (kept to just the account number so the filter chip pill stays compact), the
// `Filter Applied` analytics payload has no size constraint, so it includes the supplier name too.
export const formatAccountsAnalyticsValue = (selectedIds: string[], accounts: SupplierAccountOption[]): string => {
  const labelByContactId = new Map(accounts.map((account) => [account.contactId, getAccountAnalyticsLabel(account)]))

  return selectedIds.map((id) => labelByContactId.get(id) || id).join(', ')
}
